import React, {useState, useEffect} from 'react';
import { motion } from 'framer-motion';
// // import Tooltip from 'react-tooltip';
import {images} from '../../constants';

import { AppWrap, MotionWrap } from '../../wrapper';
import './Skills.scss';
const experience_01 = [
  {
    year: '2021 - Present',
    works: [{
      name: 'B.Tech (Computer Science)',
      company: 'Shri Shankaracharya Technical Campus',
      desc: 'CGPA : 9.15'
    }
  ]
  },
  {
    year: '2020 - 2021',
    works: [{
      name: 'Intermediate (12th Grade)',
      company: 'Vidya Jyoti School',
      desc: 'CGPA : 8.35'
    }
  ]
  }
]

const skill_02 = [
  {
    name: 'Html5',
    bgColor: '',
    icon: `${images.html}`
  },
  {
    name: 'CSS3',
    bgColor: '',
    icon: `${images.css}`
  },
  {
    name: 'JavaScript',
    bgColor: '',
    icon: `${images.javascript}`
  },
  {
    name: 'Sass',
    bgColor: '',
    icon: `${images.sass}`
  },
  {
    name: 'Tailwind',
    bgColor: '',
    icon: `${images.tailwind}`
  },
  {
    name: 'React',
    bgColor: '',
    icon: `${images.react}`
  },
  {
    name: 'Linux',
    bgColor: '',
    icon: `${images.linux}`
  },
  {
    name: 'Git & GitHub',
    bgColor: '',
    icon: `${images.git}`
  }
  
  
  
]

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {

      setExperiences(experience_01);

    
      setSkills(skill_02);
    
  }, []);

  return (
    <>
      <h1 className="head-text">Skills & Education</h1>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div
              className="app__skills-exp-item"
              key={experience.year}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                      key={work.name}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <motion.div
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </motion.div>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div> </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);

// export default Skills;
